import React, { useState } from 'react'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import { Spinner } from '../../Loaders/Loaders'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import * as api from '../../../requests'

const SettingsRegisteredAgentSearch = ({ onChange }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [searchName, setSearchName] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [showSpinner, setShowSpinner] = useState(false)
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState(false)

  const searchForAgents = (name = searchName) => {
    if (!name) return
    setHasSearchBeenMade(true)
    setShowSpinner(true)
    api.BO_SEARCH(
      { SearchName: name, QueryTypeID: '2' },
      'registeredAgentEntitySearch',
      (data) => {
        setShowSpinner(false)
        setSearchResults(data)
      },
      (err) => {
        console.error(err)
        setShowSpinner(false)
        setSearchResults([])
      }
    )
  }

  const resetState = () => {
    setModalOpen(false)
    setSearchResults([])
    setHasSearchBeenMade(false)
    setSearchName('')
  }

  const selectAgent = (result) => {
    onChange({ RegisteredAgentRecordId: result['SourceID'], RegisteredAgentName: result['Name'] })
    resetState()
  }

  return (
    <div>
      <div className="property-label user-search-header">
        <ContextButton onClick={() => setModalOpen(true)}>Search Registered Agents</ContextButton>
      </div>
      <Portal isOpened={modalOpen}>
        <Modal
          title="Search Registered Agents"
          modalSize="extra-large"
          cancelButton
          autoHeight
          closeModal={() => resetState()}
        >
          <div className="wvm-modal">
            <div className="flex-column-wrapper paper-process-container">
              <div style={{ margin: '5px', padding: '15px' }}>
                <div className="filingSelectButtonWrapper">
                  <SearchBox
                    placeholder="Agent Name"
                    value={searchName}
                    onChange={(val) => setSearchName(val)}
                    showClearButton={false}
                    showSearchButton={false}
                    onSubmit={(val) => searchForAgents(val)}
                  />
                  <div className="search-bar">
                    <ContextButton
                      variant="danger"
                      onClick={() => {
                        setSearchName('')
                        setHasSearchBeenMade(false)
                        setSearchResults([])
                      }}
                    >
                      Clear
                    </ContextButton>
                    <ContextButton variant="primary" onClick={() => searchForAgents()}>
                      Search
                    </ContextButton>
                  </div>
                </div>
              </div>
              {searchResults.length === 0 && !showSpinner && (
                <div style={{ textAlign: 'center', width: '100%' }}>
                  <h1 style={{ padding: '15px', fontWeight: 'bold' }}>
                    {hasSearchBeenMade
                      ? 'No Records Found - Please Refine Search'
                      : 'Please Search for a Registered Agent'}
                  </h1>
                </div>
              )}
              {showSpinner && (
                <div
                  style={{ height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  className="form-blocks"
                >
                  <Spinner className="page-loader" themeColor="neutral" />
                </div>
              )}
              <div className="search-wrapper paper-process-result-wrapper">
                {searchResults.length > 0 &&
                  !showSpinner &&
                  searchResults.map((result, i) => (
                    <div
                      key={i}
                      className="stacked-data-result paper-process-result-item"
                      type="button"
                      onClick={() => selectAgent(result)}
                    >
                      <div className="row">
                        <div className="search-result">
                          <span className="primary">{result['Name']}</span>
                          <span className="secondary">{`File #: ${result['File #']}`}</span>
                          {result['Status'] && <span className="secondary">{`Status: ${result['Status']}`}</span>}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </Modal>
      </Portal>
    </div>
  )
}

export default SettingsRegisteredAgentSearch
